import React from 'react';
import './App.css';
import HeadShot from './headShot.jpg';
import Grid from '@mui/material/Grid';
import {Typography, Paper, Link, Button} from '@mui/material';
import { HashRouter, Route, Routes, } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

import ZeroIndegreePage from "./ZeroIndegreePage";
import IntroAlgorithmsPage from "./IntroAlgorithmsPage";
import BFSInteractivePage from "./BFSInteractivePage";
import KruskalInteractivePage from "./KruskalInteractivePage";
import MaxFlowMinCutInteractivePage from "./MaxFlowMinCutInteractivePage";
import SumStep from './3SumAlgoVis';
import ToggleVisualization from "./AverageCaseMatrixMultDisplay";
import Publications from "./Publications";
import NavBar from "./NavBar";
import StudentsPage from "./StudentsPage";
import LLMCodingPage from "./LLMCodingPage";

function InfoItem({title, content}){
  return(
      <Grid item xs={12} sm={6} md={3}>
        <Paper style={{ padding: '10px' }}>
          <Typography variant="h5">{title}</Typography>
          {content}
        </Paper>
      </Grid>
  );
}

function InfoSection(){
  return (
   <section className="info-section">
        <Grid container spacing={2} style={{ backgroundColor: '#EDE7F6', padding: '20px' }}>
          <InfoItem title={"Teaching"} content={
              <>
                  <Typography>CS 330 Fall 2023</Typography>
                  <Typography>CS 599L1 Spring 2024</Typography>
                  <Typography>CS 330 Fall 2023</Typography>
                  <Typography>CS 330 Spring 2025</Typography>
                  <Typography>CS 330 Fall 2025</Typography>
              </>
          }/>
          <InfoItem title={"Algorithms Advice Service"} content={
            <>
              <Typography>Algorithms Advice at BU</Typography>
              <Typography style={{ color: 'gray' }}>Algorithms Office Hours at Berkeley</Typography>
              <Typography style={{ color: 'gray' }}>Algorithms Office Hours at MIT</Typography>
            </>
          }/>
          <InfoItem title={"Education"} content={
            <>
              <Typography>PhD from MIT, 2020</Typography>
              <Typography>Masters from Stanford, 2017</Typography>
              <Typography>Undergraduate from MIT, 2014</Typography>
            </>
          }/>
          <InfoItem title={"PhD Advisor"} content={
            <>
              <Typography>Virginia Vassilevska Williams</Typography>
            </>
          }/>
          <Grid item xs={12}>
            <Paper style={{ padding: '10px' }}>
              <Typography variant="h5">Research Interests</Typography>
              <Typography>Fine Grained Complexity, AI Alignment, Average-Case Complexity, Lower Bounds, Algorithms</Typography>
            </Paper>
          </Grid>
        </Grid>
      </section>
  );
}

function ThreeSumVisualization(){
  const A = [-11, -7, 3, 4];
  const B = [-4, -3, 1, 3];
  const C = [-5, -4, 2, 3];
  return(
      <SumStep A={A} B={B} C={C} stepInterval={1000} />
  );
}

function VisualizationSections() {
  return (
    <section className="info-section">
      <Grid
        container
        spacing={1}
        style={{ backgroundColor: '#e5edf5', padding: '20px', width: '100%' }}
        direction="column"
        alignItems="center"
      >
        {/* New button to go to the list of interactives */}
        <Grid item xs={12} style={{ width: '100%', marginBottom: '12px' }}>
          <Button
            variant="contained"
            component={RouterLink}
            to="/intro-algorithms"
          >
            Intro Algorithms Interactives
          </Button>
        </Grid>

        <Grid item xs={12}>
          <ThreeSumVisualization />
        </Grid>
        <Grid item xs={12} style={{ width: '100%' }}>
          <ToggleVisualization />
        </Grid>
      </Grid>
    </section>
  );
}


function MainPage(){
  return(
      <>
        <InfoSection/>
        <section className="publication-list" style={{ paddingLeft: '20px' }}>
          <h2>Projects</h2>
            <Grid item xs={12} md={8} lg={6} style={{ paddingLeft: '20px' }}>
                <p>
                    I am a scientific advisor to the{' '}
                    <a
                        href="https://alignmentproject.aisi.gov.uk/about"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Alignment Project
                    </a>.
                    <br />
                    <span style={{ color: '#474747' }}>
                        “AI alignment means developing AI systems that operate according to our goals, without
                        unintended or harmful behaviours. It’s about making certain that AI performs reliably
                        in high-stakes environments while remaining under human oversight and control.
                        As AI becomes more capable and autonomous, solving this problem is a critical
                        generational challenge.” -AI Security Institute
                    </span>
                </p>
                <p>
                    I am collaborating with the Alignment Research Center: <a href="https://arxiv.org/abs/2410.01290" target="_blank" rel="noopener noreferrer"

                    >Towards a Law of Iterated Expectations for Heuristic Estimators. </a>
                </p>
            </Grid>
          <Grid container justifyContent="left">
            <Grid item xs={12} md={8} lg={6} style={{ paddingLeft: '20px' }}>
              <p>Residual Stream Viewer -- a tool for interpreting the residual stream of GPT2-small. You can watch the tutorial on <a href="https://www.youtube.com/watch?v=9d2fs7kt1I0" target="_blank" rel="noopener noreferrer">YouTube</a>.</p>
            </Grid>
          </Grid>

          <h2>Publications</h2>
      <Paper style={{ padding: '10px', backgroundColor: '#f5faf6'}}>
        <Grid container spacing={2}>
          <Grid item>
            <Link href="https://dblp.org/pid/59/9032.html" target="_blank" rel="noopener">
              DBLP Profile
            </Link>
          </Grid>
          <Grid item>
            <Link href="https://scholar.google.com/citations?user=o_3wS3AAAAAJ&hl=en" target="_blank" rel="noopener">
              Google Scholar Profile
            </Link>
          </Grid>
        </Grid>
      </Paper>
          <Publications/>
        </section>
      </>
  );
}


function App() {
  return (
      <HashRouter>
        <div className="App">
          <header className="App-header">
            <Grid container spacing={1}>
              <Grid item xs={3} sm={4} md={3} lg={3}>
                <img src={HeadShot} alt="Andrea Lincoln" className="half-rounded-image" />
              </Grid>
              <Grid item xs={6} sm={8} md={6} lg={6}>
                <h1>Andrea Lincoln</h1>
                <p>Assistant Professor at Boston University</p>
              </Grid>
              <Grid item xs={3} sm={4} md={3} lg={3} style={{ paddingRight: '20px', paddingBottom: '20px' }}>
                <ThreeSumVisualization/>
              </Grid>
            </Grid>
          </header>
            <NavBar/>
            <Routes>
                <Route path="/" element={ <MainPage />}/>
                <Route path="/students" element={<StudentsPage />}/>
                <Route path="/visualizations" element={<VisualizationSections />}/>
                <Route path="/llm-coding" element={<LLMCodingPage />}/>
                <Route path="/intro-algorithms" element={<IntroAlgorithmsPage />} />
                <Route path="/intro-algorithms/bfs" element={<BFSInteractivePage />} />
                <Route path="/intro-algorithms/kruskal" element={<KruskalInteractivePage />} />
                <Route
                    path="/intro-algorithms/maxflow-mincut"
                    element={<MaxFlowMinCutInteractivePage />}
                />
                <Route path="/intro-algorithms/zero-indegree" element={<ZeroIndegreePage />} />
            </Routes>
          <footer className="App-footer">
            <p>Contact me at andrea2@bu.edu | Boston University | Computer Science Department | Office CDS 1023</p>
          </footer>
        </div>
      </HashRouter>
  );
}

export default App;

